import { Loading } from "@dgs/core";
import { FC } from "react";
import { Navigate, Outlet, Route, Routes, useParams } from "react-router";
import { useRegistrationFormPreviewDetailsQuery } from "../shared/api/registrationForms";
import { EmailGatePreviewPage } from "./email-gate/EmailGatePreviewPage";
import { PreviewBannerSection } from "./PreviewBannerSection";
import { PreviewRegistrationFormProvider } from "./provider/RegistrationFormPreviewProvider";
import { RegistrationStepView } from "./RegistrationStepView";
import {
	RegistrationCancelPage,
	RegistrationCancelledPage,
	RegistrationDeclinePage,
	RegistrationDeclinedPage,
	RegistrationLandingPage,
	RegistrationNominateReplacementPage,
	RegistrationReplacedPage,
	RegistrationSummaryPage,
} from "./staticPages";

export const RegistrationPreviewPage: FC = () => {
	const { registrationId = "" } = useParams<"registrationId">();
	const { data: registrationForm, isLoading } = useRegistrationFormPreviewDetailsQuery(registrationId);

	if (isLoading || !registrationForm) {
		return <Loading />;
	}

	const entryPage = registrationForm.isEmailGateEnabled ? "email-gate" : "landing-page";

	return (
		<PreviewRegistrationFormProvider registrationForm={registrationForm}>
			<Routes>
				<Route
					element={
						<>
							<PreviewBannerSection />
							<Outlet />
						</>
					}
				>
					<Route index element={<Navigate to={entryPage} replace={true} />} />
					{registrationForm.isEmailGateEnabled && (
						<Route path="email-gate" element={<EmailGatePreviewPage registrationForm={registrationForm} />} />
					)}
					<Route path="landing-page" element={<RegistrationLandingPage />} />
					<Route path="summary" element={<RegistrationSummaryPage />} />
					<Route path="cancel" element={<RegistrationCancelPage />} />
					<Route path="cancelled" element={<RegistrationCancelledPage />} />
					<Route path="decline" element={<RegistrationDeclinePage />} />
					<Route path="declined" element={<RegistrationDeclinedPage />} />
					{registrationForm.isReplacementEnabled && (
						<>
							<Route path="nominate-replacement" element={<RegistrationNominateReplacementPage />} />
							<Route path="replaced" element={<RegistrationReplacedPage />} />
						</>
					)}
					<Route
						path=":stepId"
						element={<RegistrationStepView travelSectionSettings={registrationForm.travelSectionSettings} />}
					/>
				</Route>
			</Routes>
		</PreviewRegistrationFormProvider>
	);
};
